import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import FuncionPage from '../views/FuncionPage.vue'
import ElGrupoPage from '../views/ElGrupoPage.vue'
import GaleriaPage from '../views/GaleriaPage.vue'
import TalleresFestivalPage from '../views/TalleresFestivalPage.vue'
import TalleresAnualPage from '../views/TalleresAnualPage.vue'
import CarteleraPage from '../views/CarteleraPage.vue'
import ObrasPage from '../views/ObrasPage.vue'
import AdminLogin from '../views/AdminLogin.vue'
import AdminDashboard from '../views/AdminDashboard.vue'
import BoleteriaPage from '../views/BoleteriaPage.vue'
import BoleteriaScanner from '../views/BoleteriaScanner.vue'
import BoleteriaLink from '../views/BoleteriaLink.vue'
import BoleteriaReport from '../views/BoleteriaReport.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/funcion/:slug',
    name: 'Funcion',
    component: FuncionPage
  },
  {
    path: '/el-grupo',
    name: 'ElGrupo',
    component: ElGrupoPage
  },
  {
    path: '/galeria',
    name: 'Galeria',
    component: GaleriaPage
  },
  {
    path: '/cartelera',
    name: 'Cartelera',
    component: CarteleraPage
  },
  {
    path: '/obras',
    name: 'Obras',
    component: ObrasPage
  },
  {
    path: '/talleres/festival',
    name: 'TalleresFestival',
    component: TalleresFestivalPage
  },
  {
    path: '/talleres/anual',
    name: 'TalleresAnual',
    component: TalleresAnualPage
  },
  {
    path: '/admin',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { isAdmin: true }
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { isAdmin: true }
  },
  {
      path: '/mi-perfil',
      component: () => import('@/views/MiPerfilPage.vue'),
      meta: { title: 'Mi Perfil - Grupo Babilonia' }
    },
    {
      path: '/desuscribir',
      component: () => import('@/views/DesuscribirPage.vue'),
      meta: { title: 'Desuscribirse - Grupo Babilonia' }
    },
    {
        path: '/login',
        component: () => import('@/views/LoginPage.vue'),
        meta: { title: 'Ingresar - Grupo Babilonia' }
    },
    {
        path: '/activar-cuenta',
        component: () => import('@/views/ActivarCuentaPage.vue'),
        meta: { title: 'Activar cuenta - Grupo Babilonia' }
    },
    {
        path: '/recuperar-contrasena',
        component: () => import('@/views/RecuperarContrasenaPage.vue'),
        meta: { title: 'Recuperar contraseña - Grupo Babilonia' }
    },
    {
        path: '/resetear-contrasena',
        component: () => import('@/views/ResetearContrasenaPage.vue'),
        meta: { title: 'Nueva contraseña - Grupo Babilonia' }
    },
    {
      path: '/horas',
      name: 'Horas',
      component: () => import('@/views/HorasPage.vue'),
      meta: { isAdmin: true }
    },
    // ─── Pagos ────────────────────────
      {
        path: '/pago/exito',
        name: 'PagoExito',
        component: () => import('@/views/PagoExito.vue'),
        meta: { title: 'Pago confirmado - Grupo Babilonia' }
      },
      {
        path: '/pago/error',
        name: 'PagoError',
        component: () => import('@/views/PagoError.vue'),
        meta: { title: 'Error en el pago - Grupo Babilonia' }
      },
      {
        path: '/pago/pendiente',
        name: 'PagoPendiente',
        component: () => import('@/views/PagoError.vue'),
        meta: { title: 'Pago pendiente - Grupo Babilonia' }
      },
{ path: '/mi-cuenta', component: () => import('@/views/MiCuentaPage.vue'), meta: { title: 'Mi Cuenta - Grupo Babilonia' } },
  // ─── Boletería ────────────────────────
  {
    path: '/boleteria',
    name: 'Boleteria',
    component: BoleteriaPage,
    meta: { isAdmin: true }
  },
  {
    path: '/boleteria/scanner',
    name: 'BoleteriaScanner',
    component: BoleteriaScanner,
    meta: { isAdmin: true }
  },
  {
    path: '/boleteria/link',
    name: 'BoleteriaLink',
    component: BoleteriaLink,
    meta: { isAdmin: true }
  },
  {
    path: '/boleteria/report',
    name: 'BoleteriaReport',
    component: BoleteriaReport,
    meta: { isAdmin: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router